import React, { useState, useEffect } from "react";
import * as PermissionsConstants from "../../const/constants";
import { Button } from 'devextreme-react/button';
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const HistoryTransactionButtons = (props) => {
    const history = useHistory();
    const [viewBtnURL, setviewBtnURL] = React.useState(props.permission === PermissionsConstants.HistoryReadReceipts
        ? "/wm/history/view-receipt"
        : "/wm/history/view-shippment");
    return (
        <>
            {props.permission !== PermissionsConstants.HistoryReadAdjustments ? (
                <>
                    <Button
                        disabled={(props.disable)}
                        type="default"
                        text="View"
                        onClick={() => { history.push(viewBtnURL); }}
                    >
                    </Button>
                </>
            ) : (
                <>
                    <Button
                        disabled={(props.disable)}
                        type="default"
                        text="View"
                        onClick={() => {
                            history.push(props.permission === PermissionsConstants.HistoryReadReceipts ||
                                props.permission === PermissionsConstants.HistoryReadAdjustments
                                ? "/wm/history/view-receipt"
                                : "");
                        }}
                    >
                    </Button>
                </>
            )}
        </>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HistoryTransactionButtons);
